/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./HighchartsService";
import * as i2 from "./ChartComponent";
var styles_ChartComponent = [];
var RenderType_ChartComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_ChartComponent, data: {} });
export { RenderType_ChartComponent as RenderType_ChartComponent };
export function View_ChartComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\u00A0"]))], null, null); }
export function View_ChartComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 5, "chart", [], null, null, null, View_ChartComponent_0, RenderType_ChartComponent)), i0.ɵprd(512, null, i1.HighchartsService, i1.HighchartsService, [i1.HighchartsStatic]), i0.ɵdid(2, 4243456, null, 3, i2.ChartComponent, [i0.ElementRef, i1.HighchartsService], null, null), i0.ɵqud(335544320, 1, { series: 0 }), i0.ɵqud(335544320, 2, { xAxis: 0 }), i0.ɵqud(335544320, 3, { yAxis: 0 })], null, null); }
var ChartComponentNgFactory = i0.ɵccf("chart", i2.ChartComponent, View_ChartComponent_Host_0, { type: "type", options: "options" }, { create: "create", click: "click", addSeries: "addSeries", afterPrint: "afterPrint", beforePrint: "beforePrint", drilldown: "drilldown", drillup: "drillup", load: "load", redraw: "redraw", selection: "selection" }, []);
export { ChartComponentNgFactory as ChartComponentNgFactory };



// WEBPACK FOOTER //
// ./node_modules/angular2-highcharts/dist/ChartComponent.ngfactory.js.pre-build-optimizer.js